import { ProductTypeDetailDto, ProductTypeEditDto } from './producttype';

export const mapProductTypeDetailToEdit = (
  dto: ProductTypeDetailDto
): ProductTypeEditDto => ({
  id: dto.id,
  no: dto.no,
  name: dto.name,
  active: dto.active,
  description: dto.description
});
